import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gdih_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((err) => { if (err?.response?.status === 401) localStorage.removeItem("gdih_token"); })
      .finally(() => setLoading(false));
  }, []);

  const finishLogin = (token, u) => {
    localStorage.setItem("gdih_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("gdih_token");
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, finishLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
